import styled from 'styled-components';
import A00_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/A-00-onion_garlic.jpg';
import A01_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/A-01-sweet_potato.jpg';
import A02_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/A-02-beans.jpg';
import A03_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/A-03-onion.jpg';
import A04_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/A-04-rice.jpg';
import B01_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/B-01-transplanter.jpg';
import C01_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/C-01-bean_revenue.jpg';
import C02_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/C-02-sweet_potato_revenue.jpg';
import C03_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/C-03-1_year.jpg';
import C04_THUMBNAIL from '../../../../../assets/images/pluvaAutoBusiness/C-04-1_year.jpg';
import { GoToYoutubePlayList } from './GoToYoutubePlayList';
import { VideoPlayerCard } from './VideoPlayerCard';

export interface IPluvaAutoBusinessVideo {
  thumbnailUrl: string;
  videoTitle: string;
  youtubeUrl: string;
}

interface IPluvaAutoBusinessVideoGroup {
  A00: IPluvaAutoBusinessVideo;
  A01: IPluvaAutoBusinessVideo;
  A02: IPluvaAutoBusinessVideo;
  A03: IPluvaAutoBusinessVideo;
  A04: IPluvaAutoBusinessVideo;
  B01: IPluvaAutoBusinessVideo;
  C01: IPluvaAutoBusinessVideo;
  C02: IPluvaAutoBusinessVideo;
  C03: IPluvaAutoBusinessVideo;
  C04: IPluvaAutoBusinessVideo;
}

const pluvaAutoBusinessVideoGroup: IPluvaAutoBusinessVideoGroup = {
  A00: {
    thumbnailUrl: A00_THUMBNAIL,
    videoTitle: '양파, 마늘 작업',
    youtubeUrl: 'https://www.youtube.com/watch?v=hKzZl6_f22g',
  },
  A01: {
    thumbnailUrl: A01_THUMBNAIL,
    videoTitle: '고구마 작업',
    youtubeUrl: 'https://www.youtube.com/watch?v=O9sGycIFN7w',
  },
  A02: {
    thumbnailUrl: A02_THUMBNAIL,
    videoTitle: '콩 파종 작업',
    youtubeUrl: 'https://www.youtube.com/watch?v=JuThYLJKVKc',
  },
  A03: {
    thumbnailUrl: A03_THUMBNAIL,
    videoTitle: '양파 피복 시연회',
    youtubeUrl: 'https://www.youtube.com/watch?v=end7IVHbz1c',
  },
  A04: {
    thumbnailUrl: A04_THUMBNAIL,
    videoTitle: '물 로터리 작업',
    youtubeUrl: 'https://www.youtube.com/watch?v=5MTGjJf7U-Q',
  },
  B01: {
    thumbnailUrl: B01_THUMBNAIL,
    videoTitle: '물 논 작업',
    youtubeUrl: 'https://www.youtube.com/watch?v=reIkp5jcbVY',
  },
  C01: {
    thumbnailUrl: C01_THUMBNAIL,
    videoTitle: '1년만에 기계 가격 뽑..',
    youtubeUrl: 'https://www.youtube.com/watch?v=WdeZTn2uZ8k',
  },
  C02: {
    thumbnailUrl: C02_THUMBNAIL,
    videoTitle: '수확량에 확실한..',
    youtubeUrl: 'https://www.youtube.com/watch?v=9GLOgcjfuNM',
  },
  C03: {
    thumbnailUrl: C03_THUMBNAIL,
    videoTitle: '누가해도 이것보단..',
    youtubeUrl: 'https://www.youtube.com/watch?v=L8_uXqqedB4',
  },
  C04: {
    thumbnailUrl: C04_THUMBNAIL,
    videoTitle: '밭당 150만원 증가..',
    youtubeUrl: 'https://www.youtube.com/watch?v=RnEw3_n0XiY',
  },
};

export const PluvaAutoBusinessPageContents = () => {
  return (
    <>
      <ContentWrapper>
        <ContentTitleWrapper>
          <ContentTitle>{'플루바 오토를 영상으로 만나기'}</ContentTitle>
        </ContentTitleWrapper>
        <ContentDescription>{'아래 영상을 눌러 플루바 오토에 대한 영상을 한번에 시청하세요!'}</ContentDescription>
        <GoToYoutubePlayList />
      </ContentWrapper>

      <ContentWrapperWithoutPaddingTop>
        <ContentTitleWrapper>
          <ContentTitle>{'트랙터 사용 사례'}</ContentTitle>
        </ContentTitleWrapper>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.A00} />
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.A01} />
        </ItemRow>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.A02} />
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.A03} />
        </ItemRow>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.A04} />
        </ItemRow>
      </ContentWrapperWithoutPaddingTop>

      <ContentWrapperWithoutPaddingTop>
        <ContentTitleWrapper>
          <ContentTitle>{'이앙기 사용 사례'}</ContentTitle>
        </ContentTitleWrapper>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.B01} />
        </ItemRow>
      </ContentWrapperWithoutPaddingTop>

      <ContentWrapperWithoutPaddingTop>
        <ContentTitleWrapper>
          <ContentTitle>{'수익과 편의성이 증명한 리얼 후기'}</ContentTitle>
        </ContentTitleWrapper>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.C01} />
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.C02} />
        </ItemRow>
        <ItemRow>
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.C03} />
          <VideoPlayerCard video={pluvaAutoBusinessVideoGroup.C04} />
        </ItemRow>
      </ContentWrapperWithoutPaddingTop>
    </>
  );
};

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 768px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: var(--radius-large, 16px);
  padding: 60px 120px;

  @media screen and (max-width: 768px) {
    padding: 60px 24px;
  }
`;

const ContentWrapperWithoutPaddingTop = styled.div`
  width: 100%;
  max-width: 768px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: var(--radius-large, 16px);
  padding: 0px 120px 60px 120px;

  @media screen and (max-width: 768px) {
    padding: 60px 24px;
  }
`;

const ContentTitleWrapper = styled.div`
  height: 38px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
`;

const ContentTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  font-family: Pretendard;
  font-size: 32px;
  font-style: normal;
  font-weight: 800;
  line-height: 120%; /* 38.4px */

  @media screen and (max-width: 768px) {
    color: var(--Light-Scheme-Monochrome-black, #232429);

    /* Display/XXX-Large/xxxl-bold */
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 31.2px */
  }
`;

const ContentDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/XX-Large/xxl-medium */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 30px */

  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 16px var(--radius-large, 16px);
  align-self: stretch;
  flex-wrap: wrap;
`;
